<template>
  <!-- import styles if needed -->
  <PageLoader class="mb-5 mt-5" v-if="isLoading"></PageLoader>
  <div v-if="is_loaded" v-show="!isLoading">
    <!-- import styles if needed -->

    <div v-if="is_loaded">
      <div id="current-user-wrapper">
        <snipp-current-user :campaign-id="campaignId" :user-status="user_status" @show-registration="showRegistration"
          @snipp-logout="handleSnippLogout" @show-confirmation="showConfirmation" @current-user="handleCurrentUser"
          :custom-css="customCssUrl"
          :referral-source="referralSource"
          :language="$t('Language')"></snipp-current-user>
      </div>
      <div id="registration-wrapper" v-if="registration_enabled">
        <div class="registration-inner col-md-6 col-12 mx-auto">
          <snipp-registration app-source="CampaignWidget" refresh-reload="true" :campaign-id="campaignId"
            :show-confirmation="show_confirmation"  :custom-css="customCssUrl" :is-logged-out="is_logged_out"
            @is-registered="handleIsRegistered" :referral-source="referralSource"
            :language="$t('Language')"></snipp-registration>
        </div>        
      </div>
      <div id="amoe-thanks-text" v-if="amoe_complete">
        <h1 v-html="$t('IPEwidget.AmoeThanksTitle')"></h1>
        <p v-html="$t('IPEwidget.AmoeThanksDesc')"></p>
      </div>
      <div id="thanks-text" v-if="upload_enabled === 'upload_again'">
        <h1 class="display-1" v-html="$t('IPEwidget.ThanksTitle')"></h1>
        <p v-html="$t('IPEwidget.ThanksDesc')"></p>
        <!-- <p v-html="$t('IPEwidget.TermsLink')"></p> -->
      </div>
      <div id="upload-wrapper" v-if="upload_enabled && !isAmoe">
        <div id="upload-original" v-if="upload_enabled !== 'upload_again'">
          <h2 class="text-center my-4">{{ $t('IPEwidget.UploadReceiptTitle') }}</h2>
          <div v-html="$t('IPEwidget.ImageUploadDesc1')"></div>          
          <div class="mt-4">
            <snipp-upload :campaign-id="campaignId" include-upload-button="true"
              @snipp-upload-result="handleSnippUploadResult"
              :custom-css="customCssUrl"
              :referral-source="referralSource"
              :language="$t('Language')"></snipp-upload>
          </div>
          <p class="my-4 text-center" v-html="$t('IPEwidget.ImageUplaodInstruction')"></p>
        </div>
        <div id="upload-again" v-if="upload_enabled === 'upload_again'">
          <snipp-upload :campaign-id="campaignId" include-upload-again-button="true"
            @snipp-upload-result="handleSnippUploadResult"
           :custom-css="customCssUrl"
            :referral-source="referralSource"
            :language="$t('Language')"></snipp-upload>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageLoader from '../../../components/UI/PageLoader.vue';
export default {
  components: { PageLoader },
  props: {
    campaignId: {
      type: String,
      required: true,
    },
    referralSource: {
      type: String,
      default: 'standard',
    },
  },
  emits: [],
  data() {
    return {
      ts: Date.now(),
      isLoading: true,
      is_loaded: false,
      is_logged_out: undefined,
      upload_enabled: undefined,
      registration_enabled: false,
      show_confirmation: undefined,
      user_status: undefined,
      amoe_complete: false,
      customCssUrl: window.location.origin + '/assets/css/custom_overrides.css',
    };
  },
  computed: {
    isAmoe() {
      return this.referralSource === 'amoe';
    },
  },
  methods: {
    showRegistration(confirmation) {
      if (this.upload_enabled) this.upload_enabled = undefined;
      this.amoe_complete = false;
      if (confirmation) {
        this.show_confirmation = true;
      } else {
        this.show_confirmation = undefined;
      }
      this.registration_enabled = true;
    },
    showConfirmation() {
      this.showRegistration(true);
    },
    handleSnippLogout() {
      this.upload_enabled = undefined;
      this.amoe_complete = false;
      this.is_logged_out = true;
      this.showRegistration();
    },
    handleIsRegistered() {
      this.user_status = Date.now();
      this.registration_enabled = false;
      if (this.isAmoe) {
        this.upload_enabled = undefined;
        this.amoe_complete = true;
      } else {
        this.upload_enabled = 'upload';
        this.amoe_complete = false;
      }
    },
    handleSnippUploadResult() {
      this.upload_enabled = 'upload_again';
    },
    handleCurrentUser() {
      this.registration_enabled = false;
      if (this.isAmoe) {
        this.upload_enabled = undefined;
        this.amoe_complete = true;
      } else {
        this.upload_enabled = 'upload';
        this.amoe_complete = false;
      }
    },
  },
  mounted() {
    this.is_loaded = true;
    setTimeout(() => (this.isLoading = false), 1500);
  },
};
</script>

<style scoped>
.wrapper {
  margin-top: 57px;
}

.color-red {
  color: #bf233a;
}

#current-user-wrapper,
#upload-wrapper {
  max-width: 70%;
  margin: 0 auto;
}

@media screen and (max-width: 575px) {
  #current-user-wrapper,
  #upload-wrapper {
    max-width: 100%;
    margin: 0 auto;
  }
}
</style>
